<template>
  <select
    class="form-control"
    :name="id"
    :id="id"
    :required="field.specification.required"
    v-model="value"
    @change="handleUpdate"
  >
    <option
      v-for="(optionVal, optionKey) of options"
      :value="optionKey"
      :key="optionKey"
    >
      {{ optionVal }}
    </option>
  </select>
</template>

<script>
export default {
  props: ['id', 'field'],

  data() {
    return {
      value: this.field.value,
    };
  },

  created() {
    if (this.field.specification.default && !this.value) {
      this.value = this.field.specification.default;

      this.handleUpdate();
    }
  },

  computed: {
    options() {
      if (!this.field || !this.field.specification) {
        return [];
      }

      return this.field.specification.options;
    },
  },

  methods: {
    handleUpdate() {
      this.$emit('field-update', this.field.key, this.value);
    },
  },
};
</script>
